import { render, staticRenderFns } from "./loyalty-cta.vue?vue&type=template&id=0b0b6232&"
import script from "./loyalty-cta.vue?vue&type=script&lang=js&"
export * from "./loyalty-cta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports